"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidProperties = exports.getProperties = exports.getColoredInputItems = exports.getSearchedItems = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var uniqBy_1 = tslib_1.__importDefault(require("lodash/uniqBy"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_charts_1 = require("@gooddata/sdk-ui-charts");
function getItemName(item) {
    return sdk_ui_1.getMappingHeaderName(item.mappingHeader) || "";
}
function getSearchedItems(inputItems, searchString) {
    if (isEmpty_1.default(searchString)) {
        return inputItems;
    }
    return inputItems.filter(function (item) {
        var name = getItemName(item);
        return name.toLowerCase().includes(searchString.toLowerCase());
    });
}
exports.getSearchedItems = getSearchedItems;
function getColoredInputItems(colors) {
    var inputItems = [];
    if (colors && colors.colorAssignments) {
        inputItems = colors.colorAssignments.map(function (assignmentItem, index) {
            if (sdk_model_1.isColorFromPalette(assignmentItem.color)) {
                return {
                    colorItem: assignmentItem.color,
                    mappingHeader: assignmentItem.headerItem,
                    color: sdk_ui_charts_1.ColorUtils.getColorByGuid(colors.colorPalette, assignmentItem.color.value, index),
                };
            }
            else if (sdk_model_1.isRgbColor(assignmentItem.color)) {
                return {
                    colorItem: assignmentItem.color,
                    mappingHeader: assignmentItem.headerItem,
                    color: assignmentItem.color.value,
                };
            }
        });
    }
    return inputItems;
}
exports.getColoredInputItems = getColoredInputItems;
function getMeasureMappingIdentifier(item) {
    return item.measureHeaderItem.localIdentifier;
}
function mergeColorMappingToProperties(properties, id, color) {
    var _a, _b;
    var colorMapping = [
        {
            id: id,
            color: color,
        },
    ];
    var previousColorMapping = (_b = (_a = properties === null || properties === void 0 ? void 0 : properties.controls) === null || _a === void 0 ? void 0 : _a.colorMapping) !== null && _b !== void 0 ? _b : [];
    var mergedMapping = compact_1.default(uniqBy_1.default(tslib_1.__spreadArrays(colorMapping, previousColorMapping), "id"));
    var newProperties = cloneDeep_1.default(properties);
    set_1.default(newProperties, "controls.colorMapping", mergedMapping);
    return newProperties;
}
function getProperties(properties, item, color) {
    if (sdk_backend_spi_1.isMeasureDescriptor(item)) {
        var id = getMeasureMappingIdentifier(item);
        return mergeColorMappingToProperties(properties, id, color);
    }
    else if (sdk_backend_spi_1.isResultAttributeHeader(item)) {
        return mergeColorMappingToProperties(properties, item.attributeHeaderItem.uri, color);
    }
    else if (sdk_backend_spi_1.isAttributeDescriptor(item)) {
        return mergeColorMappingToProperties(properties, item.attributeHeader.uri, color);
    }
    return {};
}
exports.getProperties = getProperties;
function getValidProperties(properties, colorAssignments) {
    if (!properties || !properties.controls || !properties.controls.colorMapping) {
        return properties;
    }
    var reducedColorMapping = properties.controls.colorMapping.filter(function (mappingItem) {
        var id = mappingItem.id;
        var colorValue = mappingItem.color.value;
        var assignmentValid = colorAssignments.find(function (colorAssignment) {
            if (sdk_backend_spi_1.isMeasureDescriptor(colorAssignment.headerItem)) {
                return (colorAssignment.headerItem.measureHeaderItem.localIdentifier === id &&
                    isEqual_1.default(colorAssignment.color.value, colorValue));
            }
            else if (sdk_backend_spi_1.isResultAttributeHeader(colorAssignment.headerItem)) {
                return colorAssignment.headerItem.attributeHeaderItem.uri === id;
            }
            else if (sdk_backend_spi_1.isAttributeDescriptor(colorAssignment.headerItem)) {
                return colorAssignment.headerItem.attributeHeader.uri === id;
            }
            return false;
        });
        return assignmentValid !== undefined;
    });
    return tslib_1.__assign(tslib_1.__assign({}, properties), { controls: tslib_1.__assign(tslib_1.__assign({}, properties.controls), { colorMapping: reducedColorMapping.length ? reducedColorMapping : null }) });
}
exports.getValidProperties = getValidProperties;
//# sourceMappingURL=colors.js.map